<template>
    <b-tooltip position="is-right" animated size="is-large" multilined  type="is-light" square>
      <template v-slot:content>
        <div ><span class="mdi mdi-airplane"></span>  {{ airportDetails.airportName }}</div>
        <div><span class="mdi mdi-map-marker"></span> {{ formatLocation(airportDetails) }}</div>
      </template>
      <div class="has-text-weight-bold">
        {{ airportCode }}
      </div>
    </b-tooltip>
  </template>
  
  <script>
  export default {
    name: "AirportDetails",

    props: {
      airportCode: String
    },
    data() {
      return {
        airportDetails: null
      };
    },
    mounted() {
      this.airportDetails = this.getFullAirportName(this.airportCode);
    },
    methods: {
      getFullAirportName(airportCode) {
        let airport = this.$globals.airports.find(
          (airportItem) => airportItem.code === airportCode
        );
        return airport || {};
      },
      formatLocation(airportDetails) {
      let location = `${airportDetails.city}`;
      if (airportDetails.state) {
        location += `, ${airportDetails.state}`;
      }
      location += `, ${airportDetails.countryName}`;
      return location;
    }
    },
   
  };
  </script>
  
  <style>
  .b-tooltip.is-multiline .tooltip-content {
    text-align: left !important;
  
}
  </style>
  